/* eslint-disable no-unused-vars */
import React, { useState, useMemo, Suspense } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { styled } from "@mui/system";
import styles from "./alertTables.module.css";
import vector from "../../../../assets/images/Vector.svg";
const  ManpowerParametersTable = React.lazy(()=> import("Samarth Module/components/table/manpowerParametersTable"));
const  BarChartManpowerShortage = React.lazy(()=> import("Samarth Module/components/barAndLineComboChart/barChartManpowerShortage"));
// import ManpowerParametersTable from "Samarth Module/components/table/manpowerParametersTable";
// import BarChartManpowerShortage from "Samarth Module/components/barAndLineComboChart/barChartManpowerShortage";

const DEFAULT_BG_COLOR = "#FFFFFF";
const PAGE = 0;
const ROWS_PER_PAGE = 25;

const MPI_RANGES = [
    { min: 0, max: 50, color: "#FF9998" },
    { min: 51, max: 74, color: "#FFEC9A" },
    { min: 75, max: 100, color: "#A3E1D2" }
];

const QTY_AT_RISK_RANGES = [
    { min: 0, max: 400, color: "#FF9998" },
    { min: 401, max: 650, color: "#FFEC9A" },
    { min: 651, max: 1000, color: "#A3E1D2" }
];

const PARAMETER_TABLE_DATA = [
    {
        "Parameters" : "Total production capacity per day",
        "Week N+1" : 658,
        "Week N+2" : 658,
        "Week N+3" : 658,
        "Week N+4" : 658
    },
    {
        "Parameters" : "Tons per manpower per day",
        "Week N+1" : 2,
        "Week N+2" : 2,
        "Week N+3" : 2,
        "Week N+4" : 2
    },
    {
        "Parameters" : "Production plan for the week",
        "Week N+1" : 3800,
        "Week N+2" : 3800,
        "Week N+3" : 3800,
        "Week N+4" : 3800
    },
    {
        "Parameters" : "Average plan per day",
        "Week N+1" : 633,
        "Week N+2" : 633,
        "Week N+3" : 633,
        "Week N+4" : 633
    },
    {
        "Parameters" : "Manpower required",
        "Week N+1" : 335,
        "Week N+2" : 335,
        "Week N+3" : 335,
        "Week N+4" : 335
    },
    {
        "Parameters" : "Actual Manpower (Predicted)",
        "Week N+1" : 300,
        "Week N+2" : 300,
        "Week N+3" : 300,
        "Week N+4" : 300
    },
    {
        "Parameters" : "Man power index %",
        "Week N+1" : "90%",
        "Week N+2" : "90%",
        "Week N+3" : "90%",
        "Week N+4" : "90%"
    },
    {
        "Parameters" : "Loss in production",
        "Week N+1" : -66,
        "Week N+2" : -66,
        "Week N+3" : -66,
        "Week N+4" : -66
    },
    {
        "Parameters" : "Predicted production for the week",
        "Week N+1" : 3734,
        "Week N+2" : 3734,
        "Week N+3" : 3734,
        "Week N+4" : 3734
    }
];

const getColorFromRanges = (numericValue, ranges) => {
    const range = ranges.find(({ min, max }) => numericValue >= min && numericValue <= max);
    return range ? range.color : DEFAULT_BG_COLOR;
};

const getCellBgColor = (value, colName) => {
    if (value === "-" || value === undefined || value === null) return DEFAULT_BG_COLOR;

    if (colName === 'Days to action') {
        return "#F5F5F5";
    }

    const numericValue = Number.parseFloat(value);
    if (Number.isNaN(numericValue)) return DEFAULT_BG_COLOR;

    if (colName === 'MPI') {
        return getColorFromRanges(numericValue, MPI_RANGES);
    }

    if (colName === 'Qty at risk') {
        return getColorFromRanges(numericValue, QTY_AT_RISK_RANGES);
    }

    return DEFAULT_BG_COLOR;
};

const StyledTableCell = styled(TableCell)(({ theme, value, colname }) => ({
    "&.MuiTableCell-head": {
        fontFamily: "Unilever Shilling",
        backgroundColor: "var(--primany-table-header-color)",
        color: "#fff",
        textAlign: "center",
        padding: "5px",
        fontSize: "12px",
        fontWeight: 600,
        outline: "1px solid #EAECF0",
        whiteSpace: "nowrap",
    },
    "&.MuiTableCell-body": {
        fontFamily: "Unilever Shilling",
        fontSize: "12px",
        fontWeight: 400,
        padding: "5px",
        color: "#2B2B2B",
        border: "1px solid #EAECF0",
        textAlign: "center",
        whiteSpace: "nowrap",
        backgroundColor: value ? getCellBgColor(value, colname) : "#FFFFFF",
    },
}));

const StyledTableRow = styled(TableRow)({
    backgroundColor: "#FFFFFF !important"
});

const StyledTableSubHeaderCell = styled(TableCell)({
    "&.MuiTableCell-head": {
        fontFamily: "Unilever Shilling",
        backgroundColor: "#F5F5F5",
        color: "var(--black-color)",
        textAlign: "center",
        padding: "2px",
        fontSize: "12px",
        fontWeight: 600,
        outline: "1px solid #DBDBDB",
        borderBottom: "none",
        whiteSpace: "nowrap",
    },
});
const StyledLeftEmptyCell = {
    backgroundColor: "#FFFFFF !important",
    outline: "none !important",
    borderLeft: "1px solid #EAECF0 !important",
    borderBottom: "1px solid #EAECF0 !important"
};
const ManpowerShortageTable = ({ data, columnList, type, viewType, loading = false }) => {
    const localItems = data;
    const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });
    const chartData = [
        {
            name: 'Week N+1',
            planProduction: 4000,
            predictedProduction: 2400
        },
        {
            name: 'Week N+2',
            planProduction: 3000,
            predictedProduction: 1380
        },
        {
            name: 'Week N+3',
            planProduction: 2000,
            predictedProduction: 900
        },
        {
            name: 'Week N+4',
            planProduction: 2700,
            predictedProduction: 3980
        }
    ];
    const selectedColumns = columnList.filter(a => a.visibility === true);
    const sortedData = useMemo(() => {
        if (sortConfig.key) {
            return [...localItems].sort((a, b) => {
                const valueA = a[sortConfig.key];
                const valueB = b[sortConfig.key];
                const numericA = Number(valueA);
                const numericB = Number(valueB);
                if (!Number.isNaN(numericA) && !Number.isNaN(numericB)) {
                    return sortConfig.direction === "asc" ? numericA - numericB : numericB - numericA;
                }
                if (typeof valueA === "string" && typeof valueB === "string") {
                    return sortConfig.direction === "asc"
                        ? valueA.localeCompare(valueB)
                        : valueB.localeCompare(valueA);
                }
                return 0;
            });
        }
        return localItems;
    }, [localItems, sortConfig]);
    
    const handleSort = (key) => {
        setSortConfig((prev) => ({
            key,
            direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
        }));
    };
    const colSpan = col => {
        const splitArr = col.split('+');
        return (splitArr.length > 1) ? 2 : 1;
    }
    return (
        <>
            <TableContainer className={styles.table} style={{height: "calc(100vh - 564px)"}}>
                <Table size="small" stickyHeader>
                    <TableHead>
                        {/* Main header row */}
                        <TableRow>
                            {selectedColumns.map((col, index) => {
                                return (
                                    <StyledTableCell
                                        key={`mainW-${col.label}-${index}`}
                                        colSpan={colSpan(col.label)}
                                        onClick={() => col.sortable && handleSort(col.label)}
                                        sx={{
                                            cursor: col.sortable ? "pointer" : "default",
                                            position: 'sticky',
                                            top: 0,
                                            zIndex: 2
                                        }}
                                    >
                                        <div className={styles.sortIcon}>
                                            {col.label}
                                            {col.sortable && sortConfig.key === col.label && (
                                                <img
                                                    src={vector}
                                                    alt="sort icon"
                                                    width="14px"
                                                    height="14px"
                                                    style={{ marginLeft: "4px" }}
                                                />
                                            )}
                                        </div>
                                    </StyledTableCell>
                                );
                            })}
                        </TableRow>
                        <TableRow>
                            <StyledTableSubHeaderCell
                                sx={{
                                    ...StyledLeftEmptyCell,
                                    position: 'sticky',
                                    top: '36px', // Height of the main header
                                    zIndex: 1
                                }}
                                colSpan={3}
                            ></StyledTableSubHeaderCell>
                            <StyledTableSubHeaderCell 
                                sx={{
                                    position: 'sticky',
                                    top: '36px', // Height of the main header
                                    zIndex: 1
                                }}
                            >
                                MPI
                            </StyledTableSubHeaderCell>
                            <StyledTableSubHeaderCell 
                                sx={{
                                    position: 'sticky',
                                    top: '36px', // Height of the main header
                                    zIndex: 1
                                }}
                            >
                                Qty at risk
                            </StyledTableSubHeaderCell>
                            <StyledTableSubHeaderCell 
                                sx={{
                                    position: 'sticky',
                                    top: '36px', // Height of the main header
                                    zIndex: 1
                                }}
                            >
                                MPI
                            </StyledTableSubHeaderCell>
                            <StyledTableSubHeaderCell 
                                sx={{
                                    position: 'sticky',
                                    top: '36px', // Height of the main header
                                    zIndex: 1
                                }}
                            >
                                Qty at risk
                            </StyledTableSubHeaderCell>
                            <StyledTableSubHeaderCell 
                                sx={{
                                    position: 'sticky',
                                    top: '36px', // Height of the main header
                                    zIndex: 1
                                }}
                            >
                                MPI
                            </StyledTableSubHeaderCell>
                            <StyledTableSubHeaderCell 
                                sx={{
                                    position: 'sticky',
                                    top: '36px', // Height of the main header
                                    zIndex: 1
                                }}
                            >
                                Qty at risk
                            </StyledTableSubHeaderCell>
                            <StyledTableSubHeaderCell 
                                sx={{
                                    position: 'sticky',
                                    top: '36px', // Height of the main header
                                    zIndex: 1
                                }}
                            >
                                MPI
                            </StyledTableSubHeaderCell>
                            <StyledTableSubHeaderCell 
                                sx={{
                                    position: 'sticky',
                                    top: '36px', // Height of the main header
                                    zIndex: 1
                                }}
                            >
                                Qty at risk
                            </StyledTableSubHeaderCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {sortedData.length > 0 ? (
                            sortedData.slice(PAGE * ROWS_PER_PAGE, PAGE * ROWS_PER_PAGE + ROWS_PER_PAGE).map((alert) => (
                                <StyledTableRow key={alert["Material"] || alert["Site"] || alert["Alert ID"] || JSON.stringify(alert)}>
                                    {selectedColumns.map((col, colIdx) =>
                                        typeof alert[col.label] === "object" ? (
                                        <React.Fragment key={`${col.label}-${colIdx}`}>
                                            <StyledTableCell value={alert[col.label]["MPI"]} colname={`MPI`}>
                                                {alert[col.label]["MPI"]}
                                            </StyledTableCell>
                                            <StyledTableCell value={alert[col.label]["Qty at risk"]} colname={`Qty at risk`}>
                                                {alert[col.label]["Qty at risk"]}
                                            </StyledTableCell>
                                        </React.Fragment>
                                        ) : (
                                        <StyledTableCell value={alert[col.label]} colname={col?.label} key={`${col.label}-${colIdx}`}>{alert[col?.label]}</StyledTableCell>
                                        )
                                    )}
                                </StyledTableRow>
                            ))
                        ) : (
                            <StyledTableRow>
                                <StyledTableCell colSpan={selectedColumns.length + 4} sx={{ whiteSpace: "nowrap", minWidth: "100px" }}>
                                    Data not available...
                                </StyledTableCell>
                            </StyledTableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            <div className={styles.alertInsigtText}>
                <span>Alert insights</span>
            </div>
            <div className={styles.manpowerContainer}>
               <div className={styles.manpowerDivs}>
                    <span className={styles.PPLoss} >Predictive Production Loss</span>
                    <div className={styles.manpowerSubContainer}>
                        <Suspense fallback={<div>Data loading...</div>}><BarChartManpowerShortage chartData={chartData}/></Suspense>
                    </div>
                </div> 
               <div className={styles.manpowerDivs}>
                    <Stack direction="row" spacing={1}>
                        <Chip label={<>Total number of employees per day : <strong>348</strong></>} className={styles.chips} size="small" />
                        <Chip label={<>Overall site capacity per week : <strong>3950</strong></>} className={styles.chips} size="small" />
                        <Chip label={<>Plant running days : <strong>06</strong></>} className={styles.chips} size="small" />
                    </Stack>
                    <Suspense fallback={<div>Data loading...</div>}><ManpowerParametersTable data={PARAMETER_TABLE_DATA} /></Suspense>
               </div>
            </div>
        </>
    );
};
export default ManpowerShortageTable;